<template>
  <div :class="_class">
    <!-- @slot 折叠内容 -->
    <slot />
  </div>
</template>

<script>
import { isEmpty } from '../scripts/utils/helper';
const name = 'ten-collapse';
export default {
  name,
  model: {
    prop: 'active',
    event: 'change',
  },
  props: {
    /**
     * 当前展开项
     * @model active
     */
    active: {
      type: [Array, String, Number],
    },
    /**
     * 初始面板展开项
     */
    defaultActive: {
      type: [Array, String, Number],
    },
    /**
     * 是否手风琴模式
     */
    accordion: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _class() {
      return [
        `${name}`,
      ];
    },
    _active() {
      return this.transform(this.active);
    },
  },
  provide() {
    return {
      collapse: this,
    };
  },
  mounted() {
    this.$on('collapse.click', this.onClick);
  },
  methods: {
    transform(v) {
      let dataActive;
      if (this.accordion) {
        dataActive = !isEmpty(v) ? [...v] : [];
      } else {
        dataActive = Array.isArray(v) ? v : [];
      }
      return dataActive;
    },
    reverse(v) {
      let propActive = v;
      if (this.accordion) {
        propActive = propActive.length ? propActive[propActive.length - 1] : undefined;
      }
      return propActive;
    },
    onClick(val) {
      const newActive = [...this._active];
      const index = newActive.indexOf(val);
      if (index > -1) {
        newActive.splice(index, 1);
      } else {
        newActive.push(val);
      }
      /**
       * 返回修改的值
       * @event change
       * @param { array | string } active
       */
      this.$emit('change', this.reverse(newActive));
    },
  },
};
</script>
